import { createAction, props } from "@ngrx/store";
export const erfNoAction = createAction('[property-info] ErfNo', props());
export const farmNoAction = createAction('[property-info] FarmNo', props());
export const allotmentAction = createAction('[property-info] Allotment', props());
export const sgCodeAction = createAction('[property-info] SGCode', props());
